<template>
  <div class="mBeer-container" v-show="isLoaded">
    <div class="mSection-container" >
      <h3 class="mSection-title" v-observe-visibility="startAnimate" :class="{animate: animate}">Cerveza Indio</h3>
      <div class="red-box" :class="{animate: animate}">
        <p class="p1">
          Indio es una cerveza oscura mexicana estilo Lager Vienna creada de la fusión de
          dos ingredientes: malta dorada y notas de caramelo tostado, dándole
          leves tonos de dulzor y reduciendo los niveles de amargor.
        </p>

        <p class="p2">
          El sabor único de cerveza Indio ofrece una combinación muy especial
          para aquellos que buscan sabores auténticos y experiencias únicas.
        </p>
      </div>
      <img class="mBotella" :class="{animate: animate}" :src="botella" alt="Botella Indio" />
    </div>

    <div class="mFlex-container" :class="{onlySafari: isSafari}">
      <div class="mFeature mFeature-1" :class="{animate: animate}">
        <h5 class="property">Estilo</h5>
        <h5 class="prop-value">Lager Vienna</h5>
      </div>
      <div class="mFeature mFeature-2" :class="{animate: animate}">
        <h5 class="property">Color</h5>
        <h5 class="prop-value">Oscuro</h5>
      </div>
      <div class="mFeature mFeature-3" :class="{animate: animate}">
        <h5 class="property">Alcohol</h5>
        <h5 class="prop-value">4.1% <span>ALC. VOL.</span></h5>
      </div>
      <!-- <div class="mFeature mFeature-4" :class="{animate: animate}">
        <h5 class="property">Amargor</h5>
        <h5 class="prop-value">12 Grados</h5>
      </div> -->
      <div class="mFeature mFeature-5" :class="{animate: animate}">
        <h5 class="property">Calorías</h5>
        <h5 class="prop-value">35 Cal/<span>100 ml</span></h5>
      </div>
    </div>
  </div>
</template>

<script>
import botella from "@/assets/indio_botella.png";
import { mapGetters } from "vuex";
import Bowser from "bowser"; 

export default {
  name: "Beer",
  data() {
    return {
      botella,
      animate: false,
      isSafari: false
    };
  },
      computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible){
      if(isVisible){
      this.animate=true;
      }
      
    },
  },
  components: {},
  mounted() {

  },
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
}
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Beer.scss";
</style>
